import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import reportOtAction from '~/modules/master/redux/actions/report-ot'

const useReportOt = () => {
  const data = useSelector((state) => get(state, 'master.reportOt'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(reportOtAction, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useReportOt
